import { useCallback, useEffect, useState } from 'react'

type ObjectUrl = {
  objectURL?: string
  setObject: (blob: Blob) => Promise<void>
}

export const useObjectURL = (): ObjectUrl => {
  const [objectURL, setObjectURL] = useState<string | undefined>()
  const setObject = useCallback(async (obj: Blob): Promise<void> => {
    const url = URL.createObjectURL(obj)
    try {
      // try to decode the image in memory before attaching to DOM
      // this technique was used to reduce some flicker when switching
      // between two elements

      // This was throwing on some older browsers
      const img = document.createElement('img')
      if ('decode' in img) {
        img.src = url
        await img.decode()
      }
    } catch (e) {
      //
    }
    setObjectURL(url)
  }, [])

  useEffect(() => {
    return () => {
      if (objectURL) {
        URL.revokeObjectURL(objectURL)
      }
    }
  }, [objectURL])

  return {
    objectURL,
    setObject
  }
}
